import { Box, SvgIcon, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Wrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(6),
  background: "#FFF",
  position: "relative",

  [theme.breakpoints.down("xl")]: {
    padding: theme.spacing(3),
  },
}));

export const Content = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
});

export const Icon = styled(SvgIcon)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  width: 72,
  height: 72,
  marginBottom: theme.spacing(5),
  color: "#ebebf7",
  [theme.breakpoints.down("xl")]: {
    width: 48,
    height: 48,
    marginBottom: theme.spacing(2),
  },
}));

export const Text = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: 36,
  lineHeight: "42px",
  color: "#ebebf7",
  textAlign: "center",
  [theme.breakpoints.down("xl")]: {
    fontSize: 24,
    lineHeight: "28px",
  },
}));
